import styled from 'styled-components';

export const WizardPhotoGalleryWrapper = styled.div`
  margin-top: ${({ $inline }) => ($inline ? '0' : '12px')};

  .photo-previews {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .photo-thumb {
    position: relative;
    width: 80px;
    height: 80px;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
    border: 1.5px solid rgba(0, 0, 0, 0.08);
    background: none;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
`;

export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 16, 30, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  z-index: 1300;
`;

export const LightboxImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
`;

export const LightboxCloseButton = styled.button`
  position: fixed;
  top: 20px;
  right: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #e74c3c;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
  transition: background 0.15s ease, transform 0.15s ease;

  svg {
    font-size: 1.4rem;
  }

  &:hover {
    background: #c0392b;
    transform: scale(1.06);
  }
`;
